import { ready } from '~/core'

ready('features', '.js-features-banner', (featuresBanner) => {
  const items = document.querySelectorAll('#mainContent [data-features-banner-display="True"]')
  const featuresBannerList = `
    <ul class="features-banner__list">
    </ul>`
  let featuresBannerItem
  featuresBanner.insertAdjacentHTML('beforeend', featuresBannerList)
  items.forEach((item) => {
    const label = item.dataset.featuresBannerTitle
      ? item.dataset.featuresBannerTitle
      : item.dataset.anchorTarget.replaceAll(/-/gi, ' ')
    const ariaLabel = item.dataset.featuresBannerTitle
      ? item.dataset.featuresBannerAriaLabel
      : item.dataset.featuresBannerAriaLabel + item.dataset.anchorTarget.replaceAll(/-/gi, ' ')
    const anchor = item.id
    if (label) {
      featuresBannerItem = `<li class="features-banner__item"><a class="features-banner__link" href="#${anchor}" aria-label="${ariaLabel}">${label}</a></li>`
      featuresBanner.querySelector('.features-banner__list').insertAdjacentHTML('beforeend', featuresBannerItem)
    }
  })
})
